"use client"

import { useLocale } from "next-intl"
import Image, { StaticImageData } from "next/image"
import Link from "next/link"

type Props = {
  className?: string
  url: string
  title: string
  description: string
  img: string | StaticImageData
}

const WhatWeOfferCard = ({
  className,
  url,
  title,
  description,
  img,
}: Props) => {
    const locale=useLocale()
  return (
    <>
    <Link href={`/${locale}/${url}`}>
      <div
        className={`flex h-68 w-80 gap-4 rounded-md bg-white px-7 py-12 transition-all ${className} md:max-w-72 lg:w-full lg:max-w-sm`}
      >
        <Image alt="what we offer" src={img} className='h-12 w-12' />
        <div>
          <h3 className='mb-2 text-xl font-semibold'>
            {title}
          </h3>
          <p className='leading-8'>{description}</p>
        </div>
      </div>
      </Link>
    </>
  )
}

export default WhatWeOfferCard
